import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export async function analyzeLetter(file, consent) {
  const form = new FormData();
  form.append("consent", consent ? "true" : "false");
  form.append("image", file);
  const { data } = await client.post("/letters/analyze", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return data;
}

export async function createSample() {
  const { data } = await client.post("/letters/sample");
  return data;
}

export async function getLetter(id, ownerToken) {
  const { data } = await client.get(`/letters/${id}`, {
    params: { owner_token: ownerToken },
  });
  return data;
}

export function letterImageUrl(id, ownerToken) {
  return `${API}/letters/${id}/image?owner_token=${encodeURIComponent(ownerToken)}`;
}

export function letterIcsUrl(id, ownerToken) {
  return `${API}/letters/${id}/ics?owner_token=${encodeURIComponent(ownerToken)}`;
}

export async function sendNotifications(id, ownerToken, payload) {
  const { data } = await client.post(
    `/letters/${id}/notify`,
    payload,
    { params: { owner_token: ownerToken } }
  );
  return data;
}

export async function getSharedView(shareToken) {
  const { data } = await client.get(`/share/${shareToken}`);
  return data;
}

export async function supporterConfirm(shareToken) {
  const { data } = await client.post(`/share/${shareToken}/help`);
  return data;
}

export async function sendThankYou(shareToken, message) {
  const { data } = await client.post(`/share/${shareToken}/thank_you`, { message });
  return data;
}

export async function updateSupporterStatus(shareToken, status) {
  const { data } = await client.post(`/share/${shareToken}/status`, { status });
  return data;
}

export async function updateLetterStatus(id, ownerToken, status) {
  const { data } = await client.post(
    `/letters/${id}/status`,
    { status },
    { params: { owner_token: ownerToken } }
  );
  return data;
}

export async function escalateToBackup(id, ownerToken, slot) {
  const { data } = await client.post(
    `/letters/${id}/escalate`,
    { slot },
    { params: { owner_token: ownerToken } }
  );
  return data;
}

export async function deleteLetter(id, ownerToken) {
  const { data } = await client.delete(`/letters/${id}`, { params: { owner_token: ownerToken } });
  return data;
}

export async function replyToRetiredSupporter(id, ownerToken, index, message) {
  const { data } = await client.post(
    `/letters/${id}/retired_supporters/${index}/reply`,
    { message },
    { params: { owner_token: ownerToken } }
  );
  return data;
}

// Clear this device's ownership map so the Care Binder is emptied locally.
export function clearAllOwnership() {
  try { localStorage.removeItem("clearnext.ownership.v1"); } catch { /* ignore */ }
}

export function forgetOwnership(id) {
  try {
    const map = JSON.parse(localStorage.getItem("clearnext.ownership.v1") || "{}");
    delete map[id];
    localStorage.setItem("clearnext.ownership.v1", JSON.stringify(map));
  } catch { /* ignore */ }
}

export async function askQuestion(id, ownerToken, question) {
  const { data } = await client.post(
    `/letters/${id}/questions`,
    { question },
    { params: { owner_token: ownerToken } }
  );
  return data;
}

export async function getQuestionHistory(id, ownerToken) {
  const { data } = await client.get(`/letters/${id}/questions`, {
    params: { owner_token: ownerToken },
  });
  return data;
}

export async function generateCallScript(id, ownerToken) {
  const { data } = await client.post(
    `/letters/${id}/call_script`,
    {},
    { params: { owner_token: ownerToken }, timeout: 60000 }
  );
  return data;
}

export function sharedImageUrl(shareToken) {
  return `${API}/share/${shareToken}/image`;
}

// --- Local ownership store ---
const LS_KEY = "clearnext.ownership.v1";
export function saveOwnership(id, ownerToken, shareToken) {
  try {
    const map = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
    map[id] = { ownerToken, shareToken, savedAt: Date.now() };
    localStorage.setItem(LS_KEY, JSON.stringify(map));
  } catch { /* ignore */ }
}
export function getOwnership(id) {
  try {
    const map = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
    return map[id] || null;
  } catch { return null; }
}
export function getAllOwnership() {
  try {
    const map = JSON.parse(localStorage.getItem(LS_KEY) || "{}");
    // Returns array of { id, ownerToken, shareToken, savedAt }, newest first
    return Object.entries(map)
      .map(([id, v]) => ({ id, ...v }))
      .sort((a, b) => (b.savedAt || 0) - (a.savedAt || 0));
  } catch { return []; }
}
